import { sumBy } from 'lodash'

function sumUpParticipantsSummaryDataTaxableAccounts(summaryData) {
  return {
    totalPlans: summaryData.length,
    totalParticipants: sumBy(summaryData, 'participants'),
    ['taxableAmount']: sumBy(summaryData, 'taxableAmount'),
  }
}

export default sumUpParticipantsSummaryDataTaxableAccounts
